
import "/app/src/modules/zy-crm/components/detail-surface.module.less?modules";
export default {"section": `section-FmIS_MII`,"header": `header-lEytwDVt`,"extra": `extra-x_SVty4G`,"body": `body-RBERc2We`}
